import './cmp-links';

async function load() {
  const { AppLinks } = await import('./app-micro');

  (new AppLinks()).init();
}

setTimeout(() => load());